import humanizeString from 'humanize-string'

import { TimelineChannel } from '@avantstay/arriere-clients/dist/arriereBackoffice'

import { SPOKEPHONE_LABEL } from '../../StayTimeline.consts'
import { ChannelTone } from '../../StayTimeline.types'

interface ChannelInfo {
  tone: ChannelTone
  source?: string
}

export const CHANNEL_TONE_LABELS: Record<ChannelTone, string> = {
  sms: 'SMS',
  email: 'Email',
  chat: 'Chat',
  ota: 'OTA',
  call: 'Call',
  push: 'App push',
  other: 'Other',
  voyage: 'Voyage',
}

const ZENDESK_LABEL = 'Zendesk'

const SEND_TONES: Record<string, ChannelTone> = {
  sms: 'sms',
  email: 'email',
  ota_chat: 'ota',
  push_notification: 'push',
}

const OTA_LABELS: Record<string, string> = {
  airbnb: 'Airbnb',
  vrbo: 'VRBO',
  booking_com: 'Booking.com',
  expedia: 'Expedia',
  rentals_united: 'Rentals United',
}

const ZENDESK_CALL = /voice|call|phone/
const ZENDESK_SMS = /sms|twilio|text/
const ZENDESK_CHAT = /chat|messaging|whatsapp/

const getZendeskTone = (via: string): ChannelTone => {
  if (ZENDESK_CALL.test(via)) return 'call'
  if (ZENDESK_SMS.test(via)) return 'sms'
  if (via.includes('mail')) return 'email'
  if (ZENDESK_CHAT.test(via)) return 'chat'

  return 'other'
}

const getOtaLabel = (agency: string) => {
  if (!agency) return undefined
  return OTA_LABELS[agency] ?? humanizeString(agency).toUpperCase()
}

export const getChannelInfo = (channel: TimelineChannel, medium?: string | null): ChannelInfo => {
  const kind = medium?.trim().toLowerCase() ?? ''

  switch (channel) {
    case TimelineChannel.spoke:
      return { tone: 'sms', source: SPOKEPHONE_LABEL }
    case TimelineChannel.call:
      return { tone: 'call', source: ZENDESK_LABEL }
    case TimelineChannel.otaChat:
      return { tone: 'ota', source: getOtaLabel(kind) }
    case TimelineChannel.internalNote:
      return { tone: 'voyage' }
    case TimelineChannel.send:
      return { tone: SEND_TONES[kind] ?? 'other' }
    case TimelineChannel.zendesk:
      return { tone: getZendeskTone(kind), source: ZENDESK_LABEL }
    default:
      return { tone: 'other' }
  }
}

export const getChannelTone = (channel: TimelineChannel, medium?: string | null) => {
  return getChannelInfo(channel, medium).tone
}

export const getChannelLabel = ({ tone, source }: ChannelInfo) => {
  const label = CHANNEL_TONE_LABELS[tone]
  return source ? `${label} · ${source}` : label
}
